import React from 'react'
import logUtil from 'utils/log'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import SquatPageInviteAFriendBottomButtonContent from 'pages/Squad/containers/Friends/InviteAFriendBottomButton/Content'

export default function SquatPageInviteAFriendBottomButton () {
  const isMediumScreen = useIsMediumScreen()
  const debugProps = {
    isMediumScreen
  }

  logUtil('SquatPageInviteAFriendBottomButton').debug('debugProps=', debugProps)
  if (!isMediumScreen) {
    return <></>
  }

  return (
    <SquatPageInviteAFriendBottomButtonContent isMediumScreen={isMediumScreen} />
  )
}
